export let junk = "sHjlvc";
export default {junk};